let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fwaOq")).then(() => parcelRequire('7Hi0z'));